import copy from 'clipboard-copy';
import { SnackbarKey, useSnackbar } from 'notistack';
import React from 'react';

import { Toast } from 'src/components/Toast';

interface ChildProps {
  copy: (content: any) => void;
}

interface Props {
  children: (props: ChildProps) => React.ReactElement<any>;
}

export const CopyToClipboard: React.FC<Props> = ({ children }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const snackbarContent = (key: SnackbarKey) => (
    <div key={key}>
      <Toast
        variant="neutral"
        description="Copied to clipboard!"
        onClose={() => closeSnackbar(key)}
      />
    </div>
  );

  const onCopy = (content: any) => {
    copy(content);

    enqueueSnackbar('', {
      content: snackbarContent,
    });
  };

  return <div>{children({ copy: onCopy }) as React.ReactElement<any>}</div>;
};
